import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { NotificationService } from '../../../../../common/services/notification/notification.service';
import { Error, CustomHttpErrorResponse } from '../../../../../common/constants/error';
import { ShipmentTransportOrderStatusChainService } from './shipment-transport-order-status-chain.service';
import {
  ShipmentTransportOrderStatusChainLoad,
  ShipmentTransportOrderStatusChainSetInitialState,
} from './shipment-transport-order-status-chain.actions';
import { ShipmentTransportOrderStatusChainModel } from '../../models';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export interface ShipmentTransportOrderStatusChainStateModel {
  statusChain: ShipmentTransportOrderStatusChainModel[];
  loaded: boolean;
}

const initialState: ShipmentTransportOrderStatusChainStateModel = {
  statusChain: [],
  loaded: false,
};

@State<ShipmentTransportOrderStatusChainStateModel>({
  name: 'shipmentTransportOrderStatusChain',
  defaults: initialState,
})
@Injectable()
export class ShipmentTransportOrderStatusChainState {
  constructor(
    private shipmentTransportOrderStatusChainService: ShipmentTransportOrderStatusChainService,
    private notificationService: NotificationService,
  ) {}
  @Selector()
  static getState(state: ShipmentTransportOrderStatusChainStateModel): ShipmentTransportOrderStatusChainStateModel {
    return state;
  }

  @Selector()
  static getLoaded(state: ShipmentTransportOrderStatusChainStateModel): boolean {
    return state.loaded;
  }

  @Selector()
  static getStatusChainView(
    state: ShipmentTransportOrderStatusChainStateModel,
  ): ShipmentTransportOrderStatusChainModel[] {
    return state.statusChain;
  }

  @Action(ShipmentTransportOrderStatusChainLoad)
  getLoadStatusChain(
    ctx: StateContext<ShipmentTransportOrderStatusChainStateModel>,
    { payload }: ShipmentTransportOrderStatusChainLoad,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.shipmentTransportOrderStatusChainService.getStatusChainData(payload).pipe(
      map(({ milestones }: { milestones: ShipmentTransportOrderStatusChainModel[] }) => {
        ctx.patchState({ statusChain: milestones, loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(ShipmentTransportOrderStatusChainSetInitialState)
  setInitialState(ctx: StateContext<ShipmentTransportOrderStatusChainStateModel>): void {
    ctx.setState(initialState);
  }
}
